import {apiClient} from '@common/http/query-client';

export type StorageAddonSku = '1tb' | '2tb';

export const STORAGE_ADDON_OPTIONS: {
  sku: StorageAddonSku;
  label: string;
  price: string;
  bonusBytes: number;
}[] = [
  {
    sku: '1tb',
    label: '+1TB storage',
    price: '$90.00',
    bonusBytes: 1000 * 1073741824,
  },
  {
    sku: '2tb',
    label: '+2TB storage',
    price: '$180.00',
    bonusBytes: 2000 * 1073741824,
  },
];

/** Buy Once base 2TB + max +2TB = 4TB total (same GiB math as plan seed). */
export const STORAGE_ADDON_MAX_TOTAL_BYTES = 4000 * 1073741824;

export async function createStorageAddonCheckout(
  sku: StorageAddonSku,
): Promise<{clientSecret: string}> {
  const {data} = await apiClient.post<{clientSecret: string}>(
    'billing/storage-addon/checkout',
    {sku},
  );
  return data;
}

export async function confirmStorageAddonPurchase(
  paymentIntentId: string,
): Promise<{storage_bonus_bytes: number}> {
  const {data} = await apiClient.post<{storage_bonus_bytes: number}>(
    'billing/storage-addon/confirm',
    {payment_intent_id: paymentIntentId},
  );
  return data;
}
